import { DateTime } from "@bps/date-time";

import {
  UnavailabilityDto,
  UnavailabilityResponseDto,
  UnavailabilityUpdateDto
} from "./unavailability.dtos";

export const mapStringsToDates = (
  data: UnavailabilityResponseDto
): UnavailabilityDto => {
  const { startDate, endDate, ...rest } = data;
  return {
    ...rest,
    startDate: new Date(startDate),
    endDate: endDate ? new Date(endDate) : undefined
  };
};

export const mapDatesToStrings = (data: UnavailabilityUpdateDto) => {
  const { startDate, endDate, ...rest } = data;
  return {
    startDate: DateTime.fromJSDate(startDate).toISODate(),
    endDate: endDate ? DateTime.fromJSDate(endDate).toISODate() : null,
    ...rest
  };
};
